<div class="modal-header">
  <h5 class="modal-title mt-0">{{ title || ('image_viewer.title' | translate) }}</h5>
  <button type="button" class="btn-close" (click)="modal.hide()"><span aria-hidden="true"></span></button>
</div>

<div class="modal-body image-viewer-body d-flex justify-content-center align-items-center">
  <img
    *ngIf="!showPlaceholder"
    class="image-viewer-image"
    [src]="imageUrl"
    [alt]="title || ''"
    (error)="onError()">

  <div *ngIf="showPlaceholder" class="image-viewer-placeholder d-flex flex-column justify-content-center align-items-center text-muted">
    <i class="bx bx-image-alt"></i>
    <span class="mt-2">{{ (imageUrl ? 'image_viewer.broken' : 'image_viewer.empty') | translate }}</span>
  </div>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-secondary" (click)="modal.hide()">{{ 'buttons.close' | translate }}</button>
</div>
